import { CTAResource } from "../ctaResource/CTAResource";
import { clickableAreaCTAFunction } from "./clickableArea/clickableAreaCTA";
import { clickableAreaConditionalCTAFunction } from "./clickableAreaConditional/clickableAreaConditionalCTA";
import { clickableButtonCTAFunction } from "./clickableButton/clickableButtonCTA";

// @ts-ignore
import clickableAreaHTML from "./clickableArea/clickableAreaCTA.html";
// @ts-ignore
import clickableAreaConditionalHTML from "./clickableAreaConditional/clickableAreaConditionalCTA.html";
// @ts-ignore
import clickableButtonHTML from "./clickableButton/clickableButtonCTA.html";

const createPrepackagedCTAs = () => {
  const map = new Map<string, CTAResource>();
  map.set("clickableareaconditional_new", new CTAResource(clickableAreaConditionalCTAFunction, clickableAreaConditionalHTML));
  map.set("clickableAreaConditional", new CTAResource(clickableAreaConditionalCTAFunction, clickableAreaConditionalHTML));
  map.set("clickableArea", new CTAResource(clickableAreaCTAFunction, clickableAreaHTML));
  map.set("clickableButton", new CTAResource(clickableButtonCTAFunction, clickableButtonHTML));
  return map;
};

export const prepackagedCTAs = createPrepackagedCTAs();
